"use client";

import { LandingHeader } from "@/components/landing/LandingHeader";
import { LandingFooter } from "@/components/landing/LandingFooter";

/**
 * Public route group layout
 * Включает: pricing, about, contact, product pages
 */
export default function PublicLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <main className="bg-white">
      <LandingHeader />
      {children}
      <LandingFooter />
    </main>
  );
}
